import { cn } from '@/lib/cn';

interface LevelBadgeProps {
  level: number;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

function tier(level: number): 'bronze' | 'silver' | 'gold' | 'platinum' {
  if (level >= 50) return 'platinum';
  if (level >= 25) return 'gold';
  if (level >= 10) return 'silver';
  return 'bronze';
}

const tierColors = {
  bronze: 'from-[#B98623] to-[#8E6519]',
  silver: 'from-[#A9A9A9] to-[#6B5F4E]',
  gold: 'from-[#E0AC23] to-[#B98623]',
  platinum: 'from-[#9BCAE5] to-[#3B7CA5]',
} as const;

const sizeMap = {
  sm: 'h-8 w-8 text-xs',
  md: 'h-12 w-12 text-base',
  lg: 'h-16 w-16 text-xl',
} as const;

export function LevelBadge({ level, size = 'md', className }: LevelBadgeProps) {
  const t = tier(level);
  return (
    <div
      className={cn(
        'grid place-items-center rounded-full bg-gradient-to-br font-mono font-bold text-parchment-light shadow-parchment-card',
        tierColors[t],
        sizeMap[size],
        className,
      )}
      aria-label={`Level ${level} ${t}`}
    >
      {level}
    </div>
  );
}
